import { atom, useAtom } from "jotai";

export const windowActiveAtom = atom(false);

export const useWindowActive = () => useAtom(windowActiveAtom)[0];
